angular.module('shared').directive('waiverEzidebitPaymentDetails', function() {
  return {
    restrict: 'E',
    scope: {
      waiver: '=',
      walletDetails: '=',
      pageParams: '=',
      saveWaiver: '&',
      isPaymentDetailsInvalid: '&',
      oneTimePublicKey: '='
    },
    template: require('templates/shared/waivers/payment_details/waiver_ezidebit_payment_details.html.slim'),
    controller: ["$scope", "$rootScope", function($scope, $rootScope) {
      var country, getPublicKey, gym;
      gym = $rootScope.gym;
      $scope.isExternal = $scope.waiver.form_type === 'external';
      getPublicKey = function() {
        return $scope.publicKey = $scope.waiver.gym_payment_provider === 'ezidebit' ? gym != null ? gym.payment_system_account.public_key : void 0 : gym != null ? gym.secondary_payment_system_account.public_key : void 0;
      };
      if (!$scope.isExternal) {
        getPublicKey();
      }
      country = (gym != null ? gym.country : void 0) || window.DATA.gym_country;
      return $scope.serviceAgreementUrl = (function() {
        switch (country) {
          case 'AU':
            return 'https://static.ezidebit.com.au/ServiceAgreement/AU/DDR_Service_Agreement.html';
          case 'NZ':
            return 'https://static.ezidebit.com.au/ServiceAgreement/NZ/DDR_Service_Agreement.html';
        }
      })();
    }]
  };
});
